import { saveAs } from "file-saver";

import { IMedicalRecordPdf } from "../../../../services/medical-history/medical-history.interface";

export const downloadPdf = async (pdf: IMedicalRecordPdf) => {
  try {
    const response = await fetch(pdf.url);
    if (!response.ok) {
      throw new Error(`Unexpected response ${response.status}`);
    }
    const blob = await response.blob();
    saveAs(blob, pdf.filename);
  } catch {
    // S3 CORS or network failure: fall back to a direct anchor download.
    // The S3 object is served with Content-Disposition: attachment.
    const link = document.createElement("a");
    link.href = pdf.url;
    link.download = pdf.filename;
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
